import { get } from 'app/shared/utils/fetchr';
import { useQuery } from '@tanstack/react-query';
import { ShadowEvaluationLog } from 'app/shared/eventsOld/models';
import { TRANSACTION_QUERY_KEYS } from 'app/modules/transactions/queries/keys';
import {
  ActionEventExternalId,
  TxnEventExternalId,
  txnEventExternalId,
} from 'app/shared/types/eventExternalIds';

export const useGetShadowEvaluationLog = (
  enabled?: boolean,
  eventExternalId?: TxnEventExternalId | ActionEventExternalId,
) => {
  // will always be set when query is issued
  const parsedExternalId = eventExternalId || txnEventExternalId('');
  return useQuery({
    queryKey: TRANSACTION_QUERY_KEYS.getTxnShadowEvaluation(parsedExternalId),
    queryFn: () =>
      get<ShadowEvaluationLog>(
        `/v1/txn-events/${encodeURIComponent(parsedExternalId)}/shadow_evaluation_log`,
      ),
    enabled: Boolean(enabled && !!eventExternalId),
    initialData: {
      evaluation_id: '',
      event_id: txnEventExternalId(''),
      rule_executions: {},
    },
  });
};
